import { render, staticRenderFns } from "./SwissSettings.vue?vue&type=template&id=ac573d8a&scoped=true"
import script from "./SwissSettings.vue?vue&type=script&lang=js"
export * from "./SwissSettings.vue?vue&type=script&lang=js"
import style0 from "./SwissSettings.vue?vue&type=style&index=0&id=ac573d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac573d8a",
  null
  
)

export default component.exports